import { createContext, useState } from "react";

export const NormasContext = createContext();

export const NormasProvider = ({ children }) => {

    const [templates, setTemplates] = useState([])
    const [proyectosNormas, setProyectosNormas] = useState([])
    const [normas, setNormas] = useState([])
    const [tareas, setTareas] = useState([])
    const [subtareas, setSubtareas] = useState({})
    const [muestras, setMuestras] = useState({})

    const [indicadores, setIndicadores] = useState([])
    const [metricas, setMetricas] = useState([])

    const [status, setStatus] = useState({
        templates: { loading: true, error: null },
        proyectos: { loading: true, error: null },
        normas: { loading: true, error: null },
        tareas: { loading: true, error: null },
        subtareas: { loading: true, error: null },
        muestras: { loading: true, error: null },
        indicadores: {loading: true, error: null},
        metricas: {loading: true, error: null}
    });

    // NORMAS TEMPLATES
    const fetchTemplates = async (body) => {
        setStatus(prev => ({
            ...prev,
            templates: { ...prev.templates, loading: true, error: null }
        }));
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/viewProyectTemplate`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            const data = await res.json()
            if(data.status !== 0){
                setStatus(prev => ({
                    ...prev,
                    templates: { loading: false, error: data.codeError || data.errorDetalle }
                }))
            } else {
                setTemplates(data)
                setStatus(prev => ({
                    ...prev,
                    templates: { loading: false, error: null }
                }))
            }
        } catch (error) {
            console.error("Error: Conexión con backend." || error)
            setStatus(prev => ({
                ...prev,
                templates: { loading: false, error: "Error: Conexión con backend." }
            }))
        }
    }

    // PROYECTOS
    const fetchProyectosNormas = async (body) => {
        setStatus(prev => ({
            ...prev,
            proyectos: { ...prev.proyectos, loading: true, error: null }
        }));
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/viewProyect`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            const data = await response.json() 
            if(data.status !== 0){
                setStatus(prev => ({
                    ...prev,
                    proyectos: { loading: false, error: data.codeError }
                }))
            } else {
                setProyectosNormas(data)
                setStatus(prev => ({
                    ...prev,
                    proyectos: { loading: false, error: null }
                }))
            }
        } catch (error) {
            console.error("Error: Conexión con backend." || error)
            setStatus(prev => ({
                ...prev,
                proyectos: { loading: false, error: "Error: Conexión con backend." }
            }))
        }
    }

    const fetchNormas = async () => {
        setStatus(prev => ({
            ...prev,
            normas: { ...prev.normas, loading: true, error: null }
        }))
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/viewNormas`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                },
            });
            const data = await response.json() 
            setNormas(data)
            setStatus(prev => ({
                ...prev,
                normas: { loading: false, error: null }
            }))
        } catch (error) {
            console.error("Error: Conexión con backend." || error)
            setStatus(prev => ({
                ...prev,
                normas: { loading: false, error: "Error: Conexión con backend." }
            }))
        }
    }

    const fetchTareas = async (body) => {
        setStatus(prev => ({
            ...prev,
            tareas: { ...prev.tareas, loading: true, error: null }
        }))
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/viewTask`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            const data = await response.json() 
            if(data.status !== 0){
                setStatus(prev => ({
                    ...prev,
                    tareas: { loading: false, error: data.codeError }
                }))
            } else {
                setTareas(data.objeto || [])
                setStatus(prev => ({
                    ...prev,
                    tareas: { loading: false, error: null }
                }))
            }
        } catch (error) {
            console.error("Error: Conexión con backend." || error)
            setStatus(prev => ({
                ...prev,
                tareas: { loading: false, error: "Error: Conexión con backend." }
            }))
        }
    }

    const fetchSubtareas = async (body) => {
        setStatus(prev => ({
            ...prev,
            subtareas: { ...prev.subtareas, loading: true, error: null }
        }))
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/viewSubTask`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            const data = await response.json() 
            if(data.status !== 0){
                setStatus(prev => ({
                    ...prev,
                    subtareas: { loading: false, error: data.codeError }
                }))
            } else {
                setSubtareas(prev => ({
                    ...prev,
                    [body.idtarea]: data.objeto || []
                }))
                setStatus(prev => ({
                    ...prev,
                    subtareas: { loading: false, error: null }
                }))
            }
        } catch (error) {
            console.error("Error: Conexión con backend." || error)
            setStatus(prev => ({
                ...prev,
                subtareas: { loading: false, error: "Error: Conexión con backend." }
            }))
        }
    }

    const fetchMuestras = async (body) => {
        setStatus(prev => ({
            ...prev,
            muestras: { ...prev.muestras, loading: true, error: null }
        }))
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/viewMuestra`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            const data = await response.json() 
            if ((typeof data.status !== "undefined" && data.status !== 0) || (typeof data.error !== "undefined" && data.error !== 0)){
                setStatus(prev => ({
                    ...prev,
                    muestras: { loading: false, error: data.codeError || data.ErrorDetalle || data.errorDetalle || "Error al obtener muestras" }
                }))
            } else {
                setMuestras(prev => ({
                    ...prev,
                    [body.idsubtarea]: data.objeto || []
                }))
                setStatus((prev) => ({
                    ...prev,
                    muestras: { loading: false, error: null }
                }))
            }
        } catch (error) {
            console.error("Error: Conexión con backend." || error)
            setStatus(prev => ({
                ...prev,
                muestras: { loading: false, error: "Error de conexión con backend" }
            }))
        }
    }

    // INDICADORES
    const fetchIndicadoresNormas = async (body) => {
        setStatus(prev => ({
            ...prev,
            indicadores: { ...prev.indicadores, loading: true, error: null }
        }));
        try {
            // VER INDICADORES NORMAS ISO
            const response = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            const data = await response.json()
            const errorCode = data.error ?? data.status
            if(errorCode !== 0){
                setStatus(prev => ({
                    ...prev,
                    indicadores: { loading: false, error: data.codeError || data.errorDetalle }
                }))
            } else {
                setIndicadores(data)
                setStatus(prev => ({
                    ...prev,
                    indicadores: { loading: false, error: null }
                }))
            }
        } catch (error) {
            console.error("Error: Conexión con backend." || error)
            setStatus(prev => ({
                ...prev,
                indicadores: { loading: false, error: "Error: Conexión con backend." }
            }))
        }
    }

    const fetchUltimasMetricas = async (body) => {
        setStatus(prev => ({
            ...prev,
            metricas: { ...prev.metricas, loading: true, error: null }
        }));
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/apis/dateIn/ultimas3Metricas`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            });
            const data = await response.json()
            if(data.status !== 0){
                setStatus(prev => ({
                    ...prev,
                    metricas: { loading: false, error: data.codeError || data.errorDetalle }
                }))
            } else {
                setMetricas(data)
                setStatus(prev => ({
                    ...prev,
                    metricas: { loading: false, error: null }
                }))
            }
        } catch (error) {
            console.error("Error: Conexión con backend." || error)
            setStatus(prev => ({
                ...prev,
                metricas: { loading: false, error: "Error: Conexión con backend." }
            }))
        }
    }

    return (
        <NormasContext.Provider value={{ 
            status,
            setStatus, 
            proyectosNormas, 
            fetchProyectosNormas, 
            normas, 
            fetchNormas, 
            tareas, 
            fetchTareas, 
            subtareas,
            fetchSubtareas,
            muestras,
            fetchMuestras,
            indicadores,
            fetchIndicadoresNormas,
            metricas,
            fetchUltimasMetricas,
            templates,
            setTemplates,
            fetchTemplates
        }}>
            {children}
        </NormasContext.Provider>
    )
}